export function computeAvgMonthlyContribution(allTxns, goalId, referenceDate) {
  const ref = referenceDate || new Date();
  const currentKey =
    ref.getUTCFullYear() + '-' + String(ref.getUTCMonth() + 1).padStart(2, '0');

  const contributions = (allTxns || []).filter(
    t => t && t.savingsGoalId === goalId && t.date && t.date.slice(0, 7) !== currentKey
  );

  if (contributions.length === 0) return 0;

  const byMonth = {};
  for (const t of contributions) {
    const key = t.date.slice(0, 7);
    byMonth[key] = (byMonth[key] || 0) + (Number(t.amount) || 0);
  }

  const sortedKeys = Object.keys(byMonth).sort().reverse().slice(0, 3);
  if (sortedKeys.length === 0) return 0;

  const total = sortedKeys.reduce((s, k) => s + byMonth[k], 0);
  return total / sortedKeys.length;
}

export function forecastGoalCompletion(goal, avgMonthlyContribution) {
  const target = Number(goal.target) || 0;
  const saved = Number(goal.saved) || 0;
  const remaining =
    goal.remaining !== undefined && goal.remaining !== null
      ? Number(goal.remaining)
      : Math.max(0, target - saved);

  if (remaining <= 0) {
    return { estimatedMonths: 0, estimatedDate: null, confidence: 'high' };
  }

  if (!avgMonthlyContribution || avgMonthlyContribution <= 0) {
    return { estimatedMonths: 0, estimatedDate: null, confidence: 'low' };
  }

  const estimatedMonths = Math.ceil(remaining / avgMonthlyContribution);
  const now = new Date();
  const estimatedDate = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth() + estimatedMonths,
    1
  ));

  return { estimatedMonths, estimatedDate, confidence: 'high' };
}
